import { FC } from 'react'
import { useSelector } from 'react-redux'

import { useFormField } from 'cng-common/features/form'
import { Translation } from 'cng-common/features/translations'
import { TranslationMode } from 'cng-common/features/translations/configs'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'
import { PartnerSearchFilter as SharedPartnerSearchFilter } from 'partner360/components/partnerSearchFilter'
import { IReportPartner } from 'partner360/models/report/IReportPartner'

import { IPartnerSearchFormFieldProps } from './models/iPartnerSearchFormFieldProps'

import styles from './PartnerSearchFormField.module.scss'

export const PartnerSearchFormField: FC<IPartnerSearchFormFieldProps> = ({
  formKey,
  field = 'partnerId',
  defaultValue,
  labelTranslationKey,
  tooltipTranslationKey,
  partners,
}) => {
  const { handleChange, value } = useFormField<string[]>({
    field,
    formKey,
    defaultValue,
  })

  const mode = useSelector(selectTranslationMode)

  return (
    <>
      {mode === TranslationMode.Edit && tooltipTranslationKey && (
        <Translation text={tooltipTranslationKey} />
      )}
      <SharedPartnerSearchFilter
        value={value}
        label={<Translation text={labelTranslationKey} />}
        partners={partners as IReportPartner[]}
        onChange={handleChange}
        tooltipContent={
          tooltipTranslationKey ? <Translation text={tooltipTranslationKey} /> : undefined
        }
        partnerNameClassName={styles.partnerName}
      />
    </>
  )
}
